import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, normalizeClass as _normalizeClass, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "request-password" }
const _hoisted_2 = {
  class: "request-password-content",
  key: "content"
}
const _hoisted_3 = {
  class: "pt-8",
  key: "isSent"
}
const _hoisted_4 = { class: "mb-2" }
const _hoisted_5 = { class: "request-password__field" }
const _hoisted_6 = { class: "request-password__label" }
const _hoisted_7 = ["placeholder"]
const _hoisted_8 = {
  key: 0,
  class: "request-password__error"
}
const _hoisted_9 = { class: "flex flex-justify-end" }
const _hoisted_10 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_Transition, {
      name: "fade",
      mode: "out-in"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          (_ctx.isSent)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("h1", null, _toDisplayString(_ctx.$t('REQUEST_PASSWORD.REQUEST_PASSWORD_SENT')), 1),
                _createElementVNode("p", null, _toDisplayString(_ctx.$t('REQUEST_PASSWORD.TEXT')), 1)
              ]))
            : (_openBlock(), _createElementBlock("form", {
                class: "pt-8",
                key: "form",
                onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.requestPassword && _ctx.requestPassword(...args)), ["prevent"]))
              }, [
                _createElementVNode("h1", null, _toDisplayString(_ctx.$t('REQUEST_PASSWORD.REQUEST_PASSWORD')), 1),
                _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t('REQUEST_PASSWORD.TEXT')), 1),
                _createElementVNode("label", _hoisted_5, [
                  _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t('COMMON.EMAIL')), 1),
                  _withDirectives(_createElementVNode("input", {
                    class: "request-password__input",
                    type: "email",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.request.email) = $event)),
                    placeholder: _ctx.$t("COMMON.EMAIL"),
                    onKeyup: _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => (_ctx.requestPassword && _ctx.requestPassword(...args)), ["enter"]))
                  }, null, 40, _hoisted_7), [
                    [_vModelText, _ctx.request.email]
                  ]),
                  (_ctx.errorMessage("Email"))
                    ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.errorMessage("Email")), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("button", {
                    class: _normalizeClass(["request-password__submit", { "is-loading": _ctx.isLoading }]),
                    type: "submit",
                    disabled: _ctx.isLoading
                  }, _toDisplayString(_ctx.$t('REQUEST_PASSWORD.REQUEST')), 11, _hoisted_10)
                ])
              ], 32))
        ])
      ]),
      _: 1
    })
  ]))
}